import { ActionType } from '../../../definitions/types/ActionType';
import { BlockNumberType } from '../../../definitions/types/BlockNumber';
import { EntityType } from '../../../definitions/types/Entity';
import { StateType } from '../../../definitions/types/StateType';
import { urlFromState } from '../../../utils/helpers/urlFromState';

export const removeReducer = (
  state: StateType,
  action: ActionType,
): StateType => {
  const payload: EntityType = action.payload as EntityType;
  const position = state.selected?.number || '1';
  const newState = {
    ...state,
    entities: state.entities.filter(
      ({ type, id }) => type !== payload.type || id !== payload.id,
    ),
  };

  if (
    state.selected?.type === payload.type &&
    state.selected?.id === payload.id
  ) {
    if (newState.entities[parseInt(position) - 1]) {
      newState.selected = {
        ...newState.entities[parseInt(position) - 1],
        number: position,
      };
    } else {
      newState.selected = {
        ...newState.entities[parseInt(position) - 2],
        number: `${parseInt(position) - 1}` as BlockNumberType,
      };
    }
  } else {
    newState.entities.forEach((entity, i) => {
      if (
        entity.type === state.selected?.type &&
        entity.id === state.selected?.id
      ) {
        newState.selected = {
          ...state.selected,
          number: `${i + 1}` as BlockNumberType,
        };
      }
    });
  }

  newState.url = urlFromState(newState);

  return newState;
};
